import { Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { palette } from "../../theme/palette";

const useStyles = makeStyles({
  root: {
    borderRadius: "4px",
    marginRight: "4px",
    height: "17px",
    width: (props) => props.width ?? "30px",
    backgroundColor: (props) =>
      props.backgroundColour
        ? props.backgroundColour
        : props.dark
        ? palette.darkGrey
        : palette.typography.white.high,
    color: (props) =>
      props.dark
        ? palette.typography.white.high
        : palette.typography.black.high,
  },
  label: {
    fontSize: "11px",
    padding: 0,
  },
});

const StyledChip = (props) => {
  const { dark, backgroundColour, width, ...rest } = props;
  const styles = useStyles({ dark, width, backgroundColour });

  return (
    <Chip classes={{ root: styles.root, label: styles.label }} {...rest} />
  );
};

export default StyledChip;
